/**
 * index.tsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

// Import root app
import { App } from 'app';

import { HelmetProvider } from 'react-helmet-async';

import dxDateBox from 'devextreme/ui/date_box';
import { RecoilRoot } from 'recoil';
import { configure } from 'axios-hooks';
import LRU from 'lru-cache';
import { axiosClient } from 'api/api';

const cache = new LRU({ max: 10 });
configure({ axios: axiosClient, cache });

// Set default options globally for DateBox
dxDateBox.defaultOptions({
  options: {
    useMaskBehavior: true,
  },
});

const MOUNT_NODE = document.getElementById('root') as HTMLElement;

ReactDOM.render(
  <RecoilRoot>
    <HelmetProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </HelmetProvider>
  </RecoilRoot>,
  MOUNT_NODE,
);
